import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import PrivateUrls, { DeletePrivateUrl, UpdatePrivateUrl, CustomPrivateUrl, ProtectFile, IsProtectedFile, PrivateLinkUser } from './reducer_private_urls';
import CreateUrls from './reducer_new_url';
import Tab from './reducer_change_tab';
import Tabs from './reducer_register_tab';
import {reducer as toastrReducer} from 'react-redux-toastr';
import {allUserRoles, userRolesAccess, allRolesSetting, membersSelect} from './reducer_user_roles';
import IpBlockData from './reducer_ip_block';
import Total from './reducer_total_private_link';
import S3Link from './reducer_s3';
import FileS3Status from './reducer_s3_status';
import getPlan  from './reducer_get_plan';
import InitData from './reducer_init_data';

const rootReducer = combineReducers({
    form: formReducer,
    toastr: toastrReducer,
    createUrls: CreateUrls,
    privateUrls: PrivateUrls,
    deleteUrl: DeletePrivateUrl,
    updateUrl: UpdatePrivateUrl,
    customUrl: CustomPrivateUrl,
    tab: Tab,
    protectFile: ProtectFile,
    isProtectedFile: IsProtectedFile,
    iPBlockData: IpBlockData,
    allUserRoles: allUserRoles,
    userRolesAccess: userRolesAccess,
    total: Total,
    s3Link: S3Link,
    // allRolesSetting: allRolesSetting,
    membersSelect: membersSelect,
    privateLinkUser: PrivateLinkUser,
    fileS3Status: FileS3Status,
    getPlan,
    tabs: Tabs,
    initData: InitData
});

export default rootReducer;
